/**
 * Created by claudio iozzia on 23/06/2017.
 */
import {AcceptorFn} from "../../../../models/acceptor/IAcceptor";
import {Utils} from "../../../../common/utils";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Ic} from "../../../../models/common";
import {Acceptor_Common} from "../../../../models/acceptor/acceptor_common";

const acceptOutput_Viper = (a: Ic, spec: IAppSpec): boolean => {
  function OutPowerUpperBound(ic: Ic): number {
    return Utils.isValueEmpty( spec.spec.value.input.min )
      ? Number.POSITIVE_INFINITY
      : (/* IdLim */ (0.95 * Utils.getFieldValue(ic, "designData.ILIM_min", 0))
        / 2 * 0.45 * 0.75 * spec.spec.value.input.min
      );
  }
  const outPowerUpperBound: number = OutPowerUpperBound(a);

  let requiredOutPower: number = 0;

  return spec.spec.value.output.outputs.every((out, i) => {
    const outputInRange: boolean = Utils.isValueEmpty(out.voltage) || (
        (a.vout_min <= out.voltage && out.voltage <= a.vout_max)
      );
    // il primo che fallisce comanda
    if ( ! outputInRange ) { return false; }

    // vinchè il singolo output rispetta i limiti di tensione... accumulo la power ed alla fine verifico che stia, anchessa, nei limiti
    if ( Utils.isValueReal( out.power ) ) {
      requiredOutPower += out.power;
    }

    if ( outPowerUpperBound < requiredOutPower ) {
      return false;
    }

    return true;
  });
};

export class Acceptor_DcDc_Viper extends Acceptor_Common {
  protected get output(): AcceptorFn {return acceptOutput_Viper; }
}
